<div class="dialog-container">
  <h2 mat-dialog-title>{{ dialogTitle }}</h2>

  <mat-dialog-content>
    <form [formGroup]="templateForm" class="template-form">
      <mat-form-field appearance="outline">
        <mat-label>Cím</mat-label>
        <input
          matInput
          formControlName="title"
          placeholder="Add meg a sablon címét"
          maxlength="200"
        />
        <mat-hint align="end">{{ templateForm.get("title")?.value?.length || 0 }}/200</mat-hint>
        <mat-error *ngIf="templateForm.get('title')?.invalid">
          {{ getErrorMessage("title") }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Leírás</mat-label>
        <textarea
          matInput
          formControlName="description"
          placeholder="Add meg a sablon leírását"
          rows="6"
          maxlength="1000"
        ></textarea>
        <mat-hint align="end">{{ templateForm.get("description")?.value?.length || 0 }}/1000</mat-hint>
        <mat-error *ngIf="templateForm.get('description')?.invalid">
          {{ getErrorMessage("description") }}
        </mat-error>
      </mat-form-field>

      <mat-checkbox
        class="local-checkbox"
        [checked]="templateForm.get('isGlobal')?.value === false"
        (change)="onLocalToggle($event)"
        [disabled]="isSaving"
      >
        Lokális
      </mat-checkbox>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isSaving">Mégse</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="isSaving || templateForm.invalid"
    >
      <mat-spinner diameter="20" *ngIf="isSaving" style="display: inline-block; margin-right: 8px;"></mat-spinner>
      {{ submitButtonText }}
    </button>
  </mat-dialog-actions>
</div>

